interface Props {
  className?: string;
}

const LoadingComponent: React.FC<Props> = ({ className = '' }) => {
  return <div className={`spinner-border spinner-border-sm ${className}`} role="status" />;
};

export default LoadingComponent;
